/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CourseData } from '../models/CourseData';
import type { CreateCourseRequestData } from '../models/CreateCourseRequestData';
import type { UpdateCourseRequestData } from '../models/UpdateCourseRequestData';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CourseService {
  /**
   * Create Course
   * @param requestBody
   * @returns CourseData Successful Response
   * @throws ApiError
   */
  public static createCourse(requestBody: CreateCourseRequestData): CancelablePromise<CourseData> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/course',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Get Courses
   * @returns CourseData Successful Response
   * @throws ApiError
   */
  public static getCourses(): CancelablePromise<Array<CourseData>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/course',
    });
  }

  /**
   * Update Course
   * @param requestBody
   * @returns CourseData Successful Response
   * @throws ApiError
   */
  public static updateCourse(requestBody: UpdateCourseRequestData): CancelablePromise<CourseData> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/course',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Delete Course
   * @param courseId
   * @returns any Successful Response
   * @throws ApiError
   */
  public static deleteCourse(courseId: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/course',
      query: {
        course_id: courseId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Get Course
   * @param courseId
   * @returns CourseData Successful Response
   * @throws ApiError
   */
  public static getCourse(courseId: string): CancelablePromise<CourseData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/course/{course_id}',
      path: {
        course_id: courseId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
